import { defaultStore } from '../library/firebase'

export const getServices = () => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('photographers_service')
      .where('delete', '==', false)
      // .where('delete', '==', undefined)
      .get()
      .then(doc => {
        const arr = []
        doc.forEach(doc => {
          // doc.data() is never undefined for query doc snapshots
          // console.log(doc.id, ' => ', doc.data())
          arr.push(Object.assign(doc.data(), { id: doc.id, filter: true }))
        })
        // console.log('get services :', typeof arr)
        resolve(arr)
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}

export const getService = serviceId => {
  return new Promise((resolve, reject) => {
    defaultStore
      .collection('photographers_service')
      .doc(serviceId)
      // .where('delete', '==', false)
      .get()
      .then(doc => {
        resolve(Object.assign(doc.data(), { id: doc.id }))
      })
      .catch(error => {
        console.log('Error getting document:', error)
        reject(error)
      })
  })
}
